/**
 * Throttles resize event so it fires only after user has stopped resizing the window.
 *
 * @package Qustodio\Theme
 */

const resize = () => {
  const resizeTimeout = 200;
  const throttledResizeEvent = new Event('qustodio:throttledResize');
  let isResizing;

  const finishedResize = () => {
    window.dispatchEvent(throttledResizeEvent);
  };

  const onResize = () => {
    clearTimeout(isResizing);
    isResizing = setTimeout(finishedResize, resizeTimeout);
  };

  const init = () => {
    window.addEventListener('resize', onResize);
  };

  return {
    init,
  };
};

export default resize();
